import FrameHead from 'src/lib/FrameHead';

const Head = ({ event, category, publisherSettings }) => {
  const theme = publisherSettings.theme;
  let primaryColor,
    primaryTextColor,
    secondaryColor,
    secondaryTextColor,
    featuredThemeColor,
    featuredThemeTextColor;

  if (theme) {
    primaryColor = theme.plugin_primary_button_color;
    primaryTextColor = theme.plugin_primary_button_text_color;

    secondaryColor = theme.plugin_secondary_button_color;
    secondaryTextColor = theme.plugin_secondary_button_text_color;
  } else {
    primaryColor = '#D52E16';
    primaryTextColor = '#ffffff';

    secondaryColor = '#324d5c';
    secondaryTextColor = '#ffffff';
  }

  if (publisherSettings.publisher.has_editors_picks) {
    featuredThemeColor = secondaryColor;
    featuredThemeTextColor = secondaryTextColor;
  } else {
    featuredThemeColor = primaryColor;
    featuredThemeTextColor = primaryTextColor;
  }

  const hexToRgb = (hex) => {
    const normal = hex.match(/^#([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})$/i);
    if (normal) return normal.slice(1).map((e) => parseInt(e, 16));

    const shorthand = hex.match(/^#([0-9a-f])([0-9a-f])([0-9a-f])$/i);
    if (shorthand) return shorthand.slice(1).map((e) => 0x11 * parseInt(e, 16));

    return null;
  };

  const themeStyles = `
    .background-theme {
      background: ${primaryColor} !important;
    }
    .background-featured-theme {
      background: ${featuredThemeColor} !important;
    }
    .theme-colour {
      color: ${primaryColor} !important;
    }
    .text-theme {
      color: ${primaryTextColor} !important;
    }
    .text-featured-theme {
      color: ${featuredThemeTextColor} !important;
    }
    .text-theme-alt {
      color: ${primaryColor} !important;
    }
    .hover\\:text-theme-alt:hover {
      color: ${primaryColor} !important;
    }
    .border-theme {
      border-color: ${primaryColor} !important;
    }
    .border-editors-pick-theme {
      border-color: rgb(${hexToRgb(primaryColor).join(',')}, 0.3) !important;
    }
    .border-featured-theme {
      border-color: rgb(${hexToRgb(featuredThemeColor).join(',')}, 0.3) !important;
    }

    .DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside) {
      color: ${primaryTextColor} !important;
      background: ${primaryColor} !important;
    }

    .Selectable.DayPicker .DayPicker-Day--selected:not(.DayPicker-Day--start):not(.DayPicker-Day--end):not(.DayPicker-Day--outside) {
      background-color: #efefef !important;
      color: #333 !important;
    }

    .DayPicker-Day--today {
      color: ${primaryColor} !important;
    }

    .DayPicker:not(.DayPicker--interactionDisabled) .DayPicker-Day:not(.DayPicker-Day--disabled):not(.DayPicker-Day--selected):not(.DayPicker-Day--outside):hover{
      background-color: #efefef !important;
      border-radius: 50% !important;
    }

    body {
      ${theme?.plugin_font?.length ? `font-family: ${theme.plugin_font}` : ''}
    }
  `;

  return (
    <FrameHead>
      <style type="text/css">{themeStyles}</style>
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      {Boolean(theme?.plugin_font?.length) && (
        <link
          href={`https://fonts.googleapis.com/css2?family=${theme.plugin_font}:wght@300;400;500;600;700;900&display=swap`}
          rel="stylesheet"
        />
      )}
    </FrameHead>
  );
};

export default Head;
